import styled, { keyframes } from 'styled-components/macro'

import { Link } from 'react-router-dom'
import React from 'react'

export const swing = keyframes`
  0% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(-10deg);
  }
`

const move = keyframes`
  from {
    left: -40px;
  }
  to {
    left: 100%;
  }
`

const ListItem = styled.li`
  position: relative;

  &::before,
  &:last-child::after {
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center center;
    display: block;
    content: "";
    height: 30px;
  }

  &:nth-child(1)::before {
    background-image: url(/img/birke1.svg);
  }

  &:nth-child(2)::before {
    background-image: url(/img/birke2.svg);
  }

  &:nth-child(3)::before {
    background-image: url(/img/birke3.svg);
  }

  &:nth-child(4)::before {
    background-image: url(/img/birke4.svg);
  }

  &:nth-child(5)::before {
    background-image: url(/img/birke5.svg);
  }

  &:last-child::after {
    background-image: url(/img/birke6.svg);
  }

  > span:first-child {
    display: block;
    padding: ${p => p.theme.spacing};
  }

  > span:last-child {
    position: absolute;
    display: block;
    width: 100%;
    top: 0;
  }

  > span:last-child::before,
  > span:last-child::after {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
    transform: rotateZ(-8deg);
    content: '';
    position: absolute;
    background-color: rgba(${p => p.theme.color.text.secondary}, 1);
    width: 3px;
    border-radius: 3px;
    left: 30px;
    top: 15px;
    height: 45px;
  }

  > span:last-child::after {
    transform: rotateZ(4deg);
    left: initial;
    right: 30px;
  }

  > span > a {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24), inset 0 0 25px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.3s cubic-bezier(.25,.8,.25,1);
    background-color: #fff;
    position: relative;
    font-style: italic;
    text-align: center;
    user-select: none;
    display: block;
    text-decoration: none;
    padding: ${p => p.theme.spacing};
    color: rgba(${p => p.theme.color.text.primary}, 1);

    &:hover,
    &:focus {
      box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
      outline: none;

      &::before {
        transform: translate(-3px, 3px) rotate(-3.5deg);
      }

      &::after {
        transform: translate(8px, -3px) rotate(2.4deg);
      }

      > span:nth-child(3)::before,
      > span:nth-child(3)::before {
        animation: ${swing} 2s ease-in-out infinite, ${move} 10s linear 1s;
        display: block;
      }
    }

    &::before,
    &::after {
      transition: transform 0.3s cubic-bezier(.25,.8,.25,1);
      content: '';
      height: 98%;
      position: absolute;
      width: 100%;
      z-index: -1;
    }

    &::before {
      background: #fafafa;
      box-shadow: 0 0 8px rgba(0,0,0,0.2);
      left: -5px;
      top: 4px;
      transform: rotate(-2.5deg);
    }

    &::after {
      background: #f6f6f6;
      box-shadow: 0 0 3px rgba(0,0,0,0.2);
      right: -3px;
      top: 1px;
      transform: rotate(1.4deg);
    }

    > span {
      display: block;

      &:nth-child(1) {
        font-size: 1.8rem;
      }

      &:nth-child(2) {
        color: rgba(${p => p.theme.color.text.secondary}, 1);
      }

      &:nth-child(3) {
        overflow: hidden;
        position: absolute;
        height: 100%;
        width: 100%;
        bottom: 0;
        left: 0;

        &::before {
          background-image: url(/img/boat.svg);
          background-size: 100% auto;
          background-repeat: no-repeat;
          background-position: center bottom;
          display: none;
          position: absolute;
          content: '';
          width: 40px;
          height: 20px;
          bottom: -4px;
          left: -40px;
        }
      }
    }
  }
`

export default ({ to, title, subtitle }) => (
  <ListItem>
    <span>
      <Link to={ to }>
        <span>{ title }</span>
        <span>{ subtitle }</span>
        <span></span>
      </Link>
    </span>
    <span></span>
  </ListItem>
)
